import { createI18n } from 'vue-i18n'
import enUS from './en-us.json'
import zhCn from './zh-cn.json'

type zhCnSchema = typeof zhCn
type enUsSchema = typeof enUS

const i18n = createI18n<[zhCnSchema, enUsSchema], 'en-us' | 'zh-cn'>({
  legacy: false, // 开启 Composition API
  locale: localStorage.getItem('lang') || 'zh-cn',
  fallbackLocale: 'zh-cn',
  messages: {
    'en-us': enUS,
    'zh-cn': zhCn
  },
  globalInjection: true
})

export default i18n
